import { render, staticRenderFns } from "./ResultEmailForm.vue?vue&type=template&id=3b849390"
import script from "./ResultEmailForm.vue?vue&type=script&lang=js"
export * from "./ResultEmailForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports